import React from 'react';
import {
  Badge,
  Copy,
  Flex,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { toTitleCase } from 'src/utilities/string-utils';
import { CreditCardIcon } from 'src/components/common/CreditCardIcon/CreditCardIcon';
import { BalanceCardBrand } from 'src/types/Balance';

export interface CreditCardDisplayProps {
  brand: BalanceCardBrand;
  expiration: {
    month: number;
    year: number;
  };
  lastFourDigits: string;
  isDefault: boolean;
  showBorder?: boolean;
}

export function CreditCardDisplay({
  brand,
  expiration,
  lastFourDigits,
  isDefault,
  showBorder = true,
}: CreditCardDisplayProps): JSX.Element {
  const expirationDate = `${expiration.month}/${expiration.year}`;
  const cardDetails = `${toTitleCase(brand)} •••• ${lastFourDigits}`;

  const content = (
    <Flex justifyContent="space-between" alignItems="center">
      <Stack>
        <Flex alignItems="center">
          <Stack x="x-sm">
            <CreditCardIcon cardBrand={brand} />
          </Stack>
          <Flex flexDirection="column">
            <Copy variant="body">{cardDetails}</Copy>
            <Copy variant="caption" color="secondaryText">
              {`Expires ${expirationDate}`}
            </Copy>
          </Flex>
        </Flex>
      </Stack>
      <Stack>
        {isDefault && (
          <Badge flavor="muted" size="sm" radius="squared">
            Default
          </Badge>
        )}
      </Stack>
    </Flex>
  );

  if (!showBorder) {
    return content;
  }

  return (
    <Square
      inset="x-sm"
      border="1px solid"
      borderColor="mediumLine"
      borderRadius="8px"
      maxWidth="375px"
    >
      {content}
    </Square>
  );
}
